// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"87":"ac437841","121":"260b12b0","275":"54a8e114","323":"169895f8","659":"cfbaf163","788":"cb0752db","849":"f171bd4c"}[chunkId] + ".chunk.css";
};